import i18n from '@/i18n'
export default [
  {
    path: 'personalCenter',
    component: () => import('@/views/modules/personalCenter/index'),
    name: 'my',
    meta: { title: '个人中心' },
    children: [
      {
        path: 'project-list',
        component: () => import('@/views/modules/personalCenter/project/index'),
        name: 'project-list',
        meta: { title: '我的项目', needToken: true }
      },
      {
        path: 'project-detail',
        component: () => import('@/views/modules/personalCenter/project/detail'),
        name: 'project-detail',
        meta: { title: '项目详情', needToken: true }
      },
      {
        path: 'selfOperation',
        component: () => import('@/views/modules/order/sass/selfOperation'),
        name: 'selfOperation',
        meta: { title: '自助运维', needToken: true }
      },
      {
        path: 'rdmsOrderList',
        component: () => import('@/views/modules/order/sass/orderList'),
        name: 'rdmsOrderList',
        meta: { title: 'RDMS套餐订单', needToken: true }
      },
      {
        path: 'securityConsole',
        component: () => import('@/views/modules/soc/securityConsole'),
        name: 'securityConsole',
        meta: { title: '安全控制台', needToken: true }
      },
      {
        path: 'basicInfo',
        component: () => import('@/views/modules/personalCenter/basic-info'),
        name: 'basicInfo',
        meta: {
          title: i18n.t('route.basicInfo'),
          needToken: true
        }
      },
      {
        path: 'organization',
        // redirect: { name: 'organizationEmployee' },
        component: () => import('@/views/modules/personalCenter/organization/index'),
        name: 'organization',
        meta: {
          title: '组织人员管理',
          needToken: true
        },
        children: [{
          path: 'postAddOrUpdate',
          component: () => import('@/views/modules/personalCenter/organization/post-add-or-update'),
          name: 'postAddOrUpdate',
          meta: {
            title: '岗位管理',
            needToken: true
          }
        }]
      },
      {
        path: 'organizationEmployeeDetail',
        component: () => import('@/views/modules/personalCenter/organization/employee-detail'),
        name: 'organizationEmployeeDetail',
        meta: {
          title: '员工详情',
          needToken: true
        }
      },
      {
        path: 'enterpriseCertification',
        component: () => import('@/views/modules/personalCenter/enterpriseApplication'),
        name: 'enterpriseCertification',
        meta: {
          title: '企业认证',
          needToken: true
        }
      },
      {
        path: 'withdraw',
        component: () => import('@/views/modules/personalCenter/withdraw'),
        name: 'withdraw',
        meta: {
          title: '账户注销',
          needToken: true
        }
      },
      {
        path: 'orderList',
        component: () => import('@/views/modules/order/orderList2'),
        name: 'orderList',
        meta: {
          title: i18n.t('route.orderList'),
          needToken: true
        }
      },
      {
        path: 'afterSalesList',
        component: () => import('@/views/modules/order/afterSales/index'),
        name: 'afterSalesList',
        meta: { title: '售后服务申请', needToken: true }
      },
      {
        path: 'afterSalesAdd',
        component: () => import('@/views/modules/order/afterSales/add'),
        name: 'afterSalesAdd',
        meta: { title: '售后服务申请', needToken: true }
      },
      {
        path: 'afterSalesDetail',
        component: () => import('@/views/modules/order/afterSales/detail'),
        name: 'afterSalesDetail',
        meta: { title: '售后服务详情', needToken: true }
      },
      {
        path: 'order-invoice',
        component: () => import('@/views/modules/order/order-invoice/index'),
        name: 'order-invoice',
        meta: { title: '开票申请', needToken: true }
      },
      {
        path: 'order-invoice-add',
        component: () => import('@/views/modules/order/order-invoice/add'),
        name: 'order-invoice-add',
        meta: { title: '开票申请新增', needToken: true }
      },
      {
        path: 'order-invoice-detail',
        component: () => import('@/views/modules/order/order-invoice/detail'),
        name: 'order-invoice-detail',
        meta: { title: '开票申请详情', needToken: true }
      },
      {
        path: 'onlineService',
        component: () => import('@/views/modules/order/sass/onlineService'),
        name: 'onlineService',
        meta: {
          title: '在线服务套餐',
          needToken: true
        }
      },
      {
        path: 'myCollection',
        component: () => import('@/views/modules/personalCenter/myCollectionCart/myCollection'),
        name: 'myCollection',
        meta: {
          title: '我的收藏',
          needToken: true
        }
      },
      {
        path: 'demandManage',
        component: () => import('@/views/modules/demandManage/demandList'),
        name: 'demandManage',
        meta: {
          title: '需求派单',
          needToken: true
        }
      },
      {
        path: 'carryoutDetaile',
        component: () => import('@/views/modules/demandManage/carryoutdetaile'),
        name: 'carryoutDetaile',
        meta: {
          title: '项目实施详细',
          needToken: true
        }
      },
      {
        path: 'addDemand',
        component: () => import('@/views/modules/demandManage/addDemand'),
        name: 'addDemand',
        meta: {
          title: '新增需求派单',
          needToken: true
        }
      },
      {
        path: 'inquiryList',
        component: () => import('@/views/modules/personalCenter/inquiry/inquiryList'),
        name: 'inquiryList',
        meta: {
          title: '我的询价单',
          needToken: true
        }
      },
      {
        path: 'productSelection',
        component: () => import('@/views/modules/personalCenter/inquiry/productSelection'),
        name: 'productSelection',
        meta: {
          title: '选型询价单',
          needToken: true
        }
      },
      {
        path: 'productSelectionDetail',
        component: () => import('@/views/modules/personalCenter/inquiry/productSelectionDetail'),
        name: 'productSelectionDetail',
        meta: {
          title: '选型询价单-详情',
          needToken: true
        }
      },
      {
        path: 'meterSelection',
        component: () => import('@/views/modules/personalCenter/meterSelection/index'),
        name: 'meterSelection',
        meta: {
          title: '设计选型需求',
          needToken: true
        }
      },
      {
        path: 'meterSelectionDetail',
        component: () => import('@/views/modules/personalCenter/meterSelection/detail'),
        name: 'meterSelectionDetail',
        meta: {
          title: '设计选型需求-详情',
          needToken: true
        }
      },
      {
        path: 'solveSonsultList',
        component: () => import('@/views/modules/personalCenter/inquiry/solveSonsultList'),
        name: 'solveSonsultList',
        meta: {
          title: '解决方案咨询',
          needToken: true
        }
      },
      {
        path: 'serviceSonsultList',
        component: () => import('@/views/modules/personalCenter/inquiry/serviceSonsultList'),
        name: 'serviceSonsultList',
        meta: {
          title: '服务咨询',
          needToken: true
        }
      },
      // {
      //   path: 'spareRequirementsList',
      //   component: () => import('@/views/modules/storeSpare/spareRequirements/spareRequirementsList'),
      //   name: 'spareRequirementsList',
      //   meta: {
      //     title: '备件需求',
      //     needToken: true
      //   }
      // },
      // {
      //   path: 'spareGetList',
      //   component: () => import('@/views/modules/storeSpare/spareGet/spareGetList'),
      //   name: 'spareGetList',
      //   meta: {
      //     title: '备件领用',
      //     needToken: true
      //   }
      // },
      // {
      //   path: 'spareStatementList',
      //   component: () => import('@/views/modules/storeSpare/spareStatement/spareStatementList'),
      //   name: 'spareStatementList',
      //   meta: {
      //     title: '对账单',
      //     needToken: true
      //   }
      // },
      // {
      //   path: 'sparePartsLibrary',
      //   component: () => import('@/views/modules/storeSpare/sparePartsLibrary/sparePartsLibrary'),
      //   name: 'sparePartsLibrary',
      //   meta: { title: '备件库', needToken: true }
      // },
      { path: 'mySubscribe', component: () => import('@/views/modules/personalCenter/myMeans/mySubscribe'), name: 'mySubscribe', meta: { title: '我的订阅' } },
      { path: 'myUpload', component: () => import('@/views/modules/personalCenter/myMeans/myUpload'), name: 'myUpload', meta: { title: '我的上传' } },
      { path: 'myDownload', component: () => import('@/views/modules/personalCenter/myMeans/myDownload'), name: 'myDownload', meta: { title: '我的下载' } },
      { path: 'myComment', component: () => import('@/views/modules/personalCenter/myMeans/myComment'), name: 'myComment', meta: { title: '我的评论' } },
      { path: 'myEvaluate', component: () => import('@/views/modules/personalCenter/myMeans/myEvaluate'), name: 'myEvaluate', meta: { title: '我的评价' } },
      { path: 'myQuestions', component: () => import('@/views/modules/personalCenter/myMeans/myQuestions'), name: 'myQuestions', meta: { title: '我的提问' } },
      { path: 'myReply', component: () => import('@/views/modules/personalCenter/myMeans/exportPosts'), name: 'myReply', meta: { title: '我的回复' } }, // 专家
      // 培训
      {
        path: 'ShopCart',
        component: () => import('@/views/modules/personalCenter/myTraining/shopCart'),
        name: 'ShopCart',
        meta: {
          title: '购物车'
        }
      },
      {
        path: 'myQuestion',
        component: () => import('@/views/modules/personalCenter/myTraining/myAsk/myQuestion'),
        name: 'myQuestion',
        meta: {
          title: '我的提问'
        }
      },
      {
        path: 'myAnswer',
        component: () => import('@/views/modules/personalCenter/myTraining/myAsk/myAnswer'),
        name: 'myAnswer',
        meta: {
          title: '我的问答'
        }
      },
      {
        path: 'myCourse',
        component: () => import('@/views/modules/personalCenter/myTraining/myStudy/myCourse'),
        name: 'myCourse',
        meta: {
          title: '我的课程'
        }
      },
      {
        path: 'myBought',
        component: () => import('@/views/modules/personalCenter/myTraining/myStudy/myBought'),
        name: 'myBought',
        meta: {
          title: '我的购买'
        }
      },
      {
        path: 'buyInvite',
        component: () => import('@/views/modules/personalCenter/myTraining/MyInvite/buyInvite'),
        name: 'buyInvite',
        meta: {
          title: '邀请购买'
        }
      },
      {
        path: 'registerInvite',
        component: () => import('@/views/modules/personalCenter/myTraining/MyInvite/registerInvite'),
        name: 'registerInvite',
        meta: {
          title: '邀请注册'
        }
      },
      {
        path: 'myCouponList',
        component: () => import('@/views/modules/personalCenter/myTraining/myCoupon/myCouponList'),
        name: 'myCoupon',
        meta: {
          title: '我的优惠券'
        }
      },
      {
        path: 'examList',
        component: () => import('@/views/modules/personalCenter/myTraining/exam/examList'),
        name: 'examList',
        meta: {
          title: '我的考试'
        }
      },
      {
        path: 'applyExam',
        component: () => import('@/views/modules/personalCenter/myTraining/exam/applyExam'),
        name: 'applyExam',
        meta: {
          title: '申请考试'
        }
      },
      {
        path: 'applyCertificate',
        component: () => import('@/views/modules/personalCenter/myTraining/exam/applyCertificate'),
        name: 'applyCertificate',
        meta: {
          title: '申请证书'
        }
      },
      {
        path: 'studyStatistics',
        component: () => import('@/views/modules/personalCenter/myTraining/StudyStatistics/studyStatistics'),
        name: 'studyStatistics',
        meta: {
          title: '我的学习'
        }
      },
      {
        path: 'liveTraining',
        component: () => import('@/views/modules/personalCenter/myTraining/live/liveTraining'),
        name: 'liveTraining',
        meta: {
          title: '专题培训'
        }
      },
      {
        path: 'equipmentList',
        component: () => import('@/views/modules/equipment/equipmentList'),
        name: 'equipmentList',
        meta: {
          title: '设备列表',
          needToken: true
        }
      }
    ]
  },
  {
    path: 'myShopCart',
    component: () => import('@/views/modules/myShopCart/index'),
    name: 'myShopCart',
    meta: {
      title: i18n.t('route.myCart'),
      needToken: true,
      hideFooter: true
    }
  },
  {
    path: 'mySpareShopCart',
    component: () => import('@/views/modules/myShopCart/spare'),
    name: 'mySpareShopCart',
    meta: {
      title: '领用车',
      needToken: true,
      hideFooter: true
    }
  },
  {
    path: 'browseHistory',
    component: () => import('@/views/modules/personalCenter/browseHistory/browseHistory'),
    name: 'browseHistory',
    meta: {
      title: '浏览历史',
      needToken: true
    }
  },
  {
    path: 'myInquiryCart',
    component: () => import('@/views/modules/personalCenter/inquiry/myInquiryCart'),
    name: 'myInquiryCart',
    meta: {
      title: '我的询价篮',
      needToken: true
    }
  },
  {
    path: 'lectotypeCart',
    component: () => import('@/views/modules/personalCenter/myCollectionCart/myShopCart'),
    name: 'lectotypeCart',
    meta: {
      title: '选型',
      needToken: true
    }
  },
  {
    path: 'inquiryCreate',
    component: () => import('@/views/modules/personalCenter/inquiry/inquiryCreate'),
    name: 'inquiryCreate',
    meta: {
      title: '询价单',
      needToken: true
    }
  },
  {
    path: 'inquiryDetail',
    component: () => import('@/views/modules/personalCenter/inquiry/inquiryDetail'),
    name: 'inquiryDetail',
    meta: {
      title: '询价单详情',
      needToken: true
    }
  },
  {
    path: 'inquiryOrderDetail',
    component: () => import('@/views/modules/personalCenter/inquiry/inquiryOrderDetail'),
    name: 'inquiryOrderDetail',
    meta: {
      title: '询价订单详情',
      needToken: true
    }
  },
  {
    path: 'integralManagment',
    component: () => import('@/views/modules/personalCenter/integral/index'),
    name: 'integralManagment',
    meta: {
      title: '积分管理',
      needToken: true
    },
    children: [
      {
        path: 'integralGetList',
        component: () => import('@/views/modules/personalCenter/integral/integralGetList'),
        name: 'integralGetList',
        meta: { title: '积分详情', needToken: true }
      },
      {
        path: 'integralOrder',
        component: () => import('@/views/modules/personalCenter/integral/integralOrder'),
        name: 'integralOrder',
        meta: { title: '积分订单', needToken: true }
      },
      {
        path: 'integralExchange',
        component: () => import('@/views/modules/personalCenter/integral/integralExchange'),
        name: 'integralExchange',
        meta: { title: '积分兑换', needToken: true }
      },
      {
        path: 'integralAddress',
        component: () => import('@/views/modules/personalCenter/integral/integralAddress'),
        name: 'integralAddress',
        meta: { title: '收货地址', needToken: true }
      }
    ]
  },
  {
    path: 'exchangeGoodDetail',
    component: () => import('@/views/modules/personalCenter/integral/exchangeGoodDetail'),
    name: 'exchangeGoodDetail',
    meta: { title: '积分商品详情', needToken: true }
  },
  {
    path: 'integralOrderCreate',
    component: () => import('@/views/modules/personalCenter/integral/integralOrderCreate'),
    name: 'integralOrderCreate',
    meta: { title: '立即兑换', needToken: true }
  },
  {
    path: 'integralAddressAdd',
    component: () => import('@/views/modules/personalCenter/integral/integralAddressAdd'),
    name: 'integralAddressAdd',
    meta: { title: '新增收货地址', needToken: true }
  },
  {
    path: 'equipmentAddOrUpdate',
    component: () => import('@/views/modules/equipment/equipment-add-or-update'),
    name: 'equipmentAddOrUpdate',
    meta: { title: '新增/编辑设备', needToken: true }
  },
  {
    path: 'equipmentDetail',
    component: () => import('@/views/modules/equipment/equipment-detail'),
    name: 'equipmentDetail',
    meta: { title: '设备详情', needToken: true }
  }
]
